import { Body1, UIHeading4 } from '@cian/ui-kit';
import { IconProductSpecialLoanRate24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type MouseEvent as ReactMouseEvent } from 'react';

import styles from './BankItem.css';

export type BankItemProps = {
  logoUrl: string | null | undefined;
  name: string;
  onLinkClick: (event: ReactMouseEvent<HTMLAnchorElement>) => void;
  url: string | null;
};

export const BankItem: FC<BankItemProps> = ({ logoUrl, name, onLinkClick, url }) => {
  return (
    <div className={styles['container']} data-testid="BankItem">
      <div className={styles['logo']}>
        {logoUrl ? (
          <img alt={name} className={styles['logo-image']} decoding="async" loading="lazy" src={logoUrl} />
        ) : (
          <div className={styles['logo-icon']} data-testid="logo-icon">
            <IconProductSpecialLoanRate24 />
          </div>
        )}
      </div>
      <div className={styles['info']}>
        <UIHeading4>{name}</UIHeading4>
        {url && (
          <Body1>
            <a className={styles['link']} href={url} onClick={onLinkClick}>
              Посмотреть ЖК
            </a>
          </Body1>
        )}
      </div>
    </div>
  );
};
